/* ============================================================
   kenania-product.js — تحسينات صفحة المنتج.
   ملف مستقل عن ملفات الثيم حتى لا تضيع التعديلات عند تحديثه.

   1) المصغّرات عمودية يسار الصورة على الديسكتوب.
   2) شريط شراء ثابت يظهر عند تمرير زر الإضافة خارج الشاشة.

   لا يعمل أي شيء منه خارج صفحة المنتج.
   ============================================================ */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 992px)';

  /* ---------------------------------------------------------
     1) اتجاه شريط المصغّرات
     نغيّر اتجاه Swiper الموجود بدل إنشاء واحد جديد، حتى تبقى
     مزامنة الصورة الكبيرة مع المصغّرة كما بناها الثيم.
     --------------------------------------------------------- */
  function syncThumbDirection(gallery) {
    var thumbEl = gallery.querySelector('.slideChild');
    var swiper = thumbEl && thumbEl.swiper;
    if (!swiper) return;

    var wantVertical = window.matchMedia(DESKTOP).matches;
    var isVertical = swiper.params.direction === 'vertical';
    if (wantVertical === isVertical) return;

    swiper.changeDirection(wantVertical ? 'vertical' : 'horizontal');
    // 'auto' يترك ارتفاع كل شريحة من مقاس صورتها بدل قسمة ارتفاع
    // الحاوية بالتساوي — وهذا ما يجعل الإطار يلتصق بحدود الصورة.
    swiper.params.slidesPerView = wantVertical ? 'auto' : 6;
    swiper.params.freeMode = true;
    swiper.update();
    syncThumbHeight(gallery);
  }

  /* ارتفاع شريط المصغّرات يطابق الصورة الكبيرة بالضبط.
     ارتفاع ثابت في CSS كان يترك فراغاً أسفل آخر مصغّرة عندما
     يكون عدد الصور أقل من عدد الشرائح المرئية. */
  function syncThumbHeight(gallery) {
    var thumbEl = gallery.querySelector('.slideChild');
    var mainEl = gallery.querySelector('.slideMain');
    if (!thumbEl || !mainEl) return;

    if (!window.matchMedia(DESKTOP).matches) {
      thumbEl.style.height = '';
      return;
    }

    var h = Math.round(mainEl.getBoundingClientRect().height);
    if (!h) return;
    thumbEl.style.height = h + 'px';
    if (thumbEl.swiper) thumbEl.swiper.update();
  }

  function initGallery() {
    var galleries = document.querySelectorAll('media-gallery');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      // media-gallery.js وحزمة Swiper كلاهما defer ويأتيان بعد هذا الملف
      // في ترتيب المستند، فقد يتأخر إنشاء Swiper مئات الميلي ثانية.
      // ننتظر حتى 6 ثوانٍ ثم نتوقف بهدوء بدل تعليق حلقة لا تنتهي.
      var waited = 0;
      var timer = setInterval(function () {
        var thumbEl = gallery.querySelector('.slideChild');
        if (thumbEl && thumbEl.swiper) {
          clearInterval(timer);
          // منتج بصورة واحدة لا يحتاج شريط مصغّرات — يظهر كمربع فارغ.
          if (gallery.querySelectorAll('.slideChild .swiper-slide').length < 2) {
            gallery.classList.add('kn-gallery--single');
            return;
          }
          gallery.classList.add('kn-gallery--ready');
          syncThumbDirection(gallery);
        } else if ((waited += 100) >= 6000) {
          clearInterval(timer);
        }
      }, 100);
    });

    window.matchMedia(DESKTOP).addEventListener('change', function () {
      galleries.forEach(syncThumbDirection);
    });

    // الصورة الكبيرة تغيّر ارتفاعها بعد تحميلها وعند تغيّر مقاس النافذة،
    // فنعيد ضبط ارتفاع الشريط في الحالتين.
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        galleries.forEach(syncThumbHeight);
      }, 120);
    });
    window.addEventListener('load', function () {
      galleries.forEach(syncThumbHeight);
    });
  }

  /* ---------------------------------------------------------
     2) شريط الشراء الثابت
     يعيد استخدام نموذج الإضافة الأصلي بدل إنشاء نموذج ثانٍ،
     فلا يوجد خطر إرسال الطلب مرتين أو اختلاف الكمية.
     --------------------------------------------------------- */
  function initStickyBar() {
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    var mainButton = form && form.querySelector('.product-form__submit');
    if (!mainButton) return;

    var titleEl = document.querySelector('.product__title, .product__info-container h1');
    if (!titleEl) return;

    // السعر: نأخذه من داخل زر الإضافة لأنه نص نظيف بالفعل.
    // كتلة .price تحتوي تسميات مخفية للقارئ الصوتي
    // (Regular price / Sale price / Unit price) لا تصلح للعرض.
    function readPrice() {
      // في وضع "إزالة من السلة" لا معنى لعرض سعر بجانب الزر.
      if (mainButton.classList.contains('kn-atc--remove')) return '';
      var inButton = mainButton.querySelector('.kn-atc__price');
      if (inButton) return inButton.textContent.replace(/^[\s—–-]+/, '').trim();
      var regular = document.querySelector('.product__info-container .price-item--regular');
      return regular ? regular.textContent.trim() : '';
    }

    // نص الزر بدون السعر، حتى لا يتكرّر السعر مرتين في الشريط.
    function readButtonLabel() {
      var span = mainButton.querySelector('span');
      if (!span) return mainButton.textContent.trim();
      var clone = span.cloneNode(true);
      var price = clone.querySelector('.kn-atc__price');
      if (price) price.remove();
      return clone.textContent.trim();
    }

    var bar = document.createElement('div');
    bar.className = 'kn-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="kn-sticky-atc__inner">' +
        '<div class="kn-sticky-atc__info">' +
          '<span class="kn-sticky-atc__title"></span>' +
          '<span class="kn-sticky-atc__price"></span>' +
        '</div>' +
        '<button type="button" class="kn-sticky-atc__button btn btn-primary"></button>' +
      '</div>';

    bar.querySelector('.kn-sticky-atc__title').textContent = titleEl.textContent.trim();
    bar.querySelector('.kn-sticky-atc__price').textContent = readPrice();

    var barButton = bar.querySelector('.kn-sticky-atc__button');
    barButton.textContent = readButtonLabel();
    barButton.disabled = mainButton.disabled;

    // الضغط يمرّر الحدث للزر الأصلي، فتعمل كل منطق الثيم كما هي.
    barButton.addEventListener('click', function () {
      mainButton.click();
    });

    document.body.appendChild(bar);

    // يظهر فقط حين يخرج الزر الأصلي من الشاشة.
    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries[0].isIntersecting;
        bar.classList.toggle('is-visible', !visible);
        bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      },
      { rootMargin: '0px 0px -40px 0px' }
    );
    observer.observe(mainButton);

    // عند أول رصد قد تكون الصور لم تُحمَّل بعد فيبدو الزر داخل الشاشة خطأً.
    // نعيد الرصد بعد اكتمال التحميل ليُحسب الموضع النهائي.
    window.addEventListener('load', function () {
      observer.unobserve(mainButton);
      observer.observe(mainButton);
    });

    // إبقاء حالة الزر متطابقة عند تغيّر المتغيّر (نفاد المخزون مثلاً).
    new MutationObserver(function () {
      barButton.disabled = mainButton.disabled;
      barButton.textContent = readButtonLabel();
      barButton.classList.toggle('kn-atc--remove', mainButton.classList.contains('kn-atc--remove'));
      bar.querySelector('.kn-sticky-atc__price').textContent = readPrice();
    }).observe(mainButton, { attributes: true, childList: true, subtree: true });
  }

  /* بانر "توصيل مجاني داخل الإمارات" في أسفل الوصف: نقرة عليه ترجع
     الزائر لصندوق الطلب مباشرة ليتمّم الشراء. البانر جزء من
     descriptionHtml في كل المنتجات فلا نستطيع تعديل وسمه هناك —
     نضيف الدور والسلوك هنا مركزياً. */
  function initBandScroll() {
    var bands = document.querySelectorAll('.knp .knp-band');
    if (!bands.length) return;
    var target =
      document.querySelector('.product-form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!target) return;
    var goToBuyBox = function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    };
    bands.forEach(function (band) {
      band.setAttribute('role', 'button');
      band.setAttribute('tabindex', '0');
      band.setAttribute('aria-label', 'اطلب الآن — الانتقال إلى صندوق الطلب');
      band.addEventListener('click', goToBuyBox);
      band.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goToBuyBox(); }
      });
    });
  }

  /* ============================================================
     عروض الكمية المحلية (بديل Vitals)
     الواجهة: snippets/kn-volume-tiers.liquid
     - اختيار شريحة يضبط حقل الكمية في نموذج المنتج نفسه فقط.
     - الخصم نفسه "خصم تلقائي" (Automatic discount) في شوبيفاي
       بشرط حد أدنى للكمية — ينطبق وحده عند الدفع، بلا أي كوبون
       وبلا أي تدخّل من هذا الكود.
     - تغيير الفاريانت يعيد حساب الأسعار من سعر الفاريانت الجديد.
     ============================================================ */
  function knpFormatMoney(cents, format) {
    var fmt = format || '{{amount}}';
    var value = (Number(cents) || 0) / 100;
    var TOKENS = {
      amount: [',', '.', 2],
      amount_no_decimals: [',', '.', 0],
      amount_with_comma_separator: ['.', ',', 2],
      amount_no_decimals_with_comma_separator: ['.', ',', 0],
      amount_with_apostrophe_separator: ["'", '.', 2],
      amount_with_space_separator: [' ', ',', 2],
      amount_no_decimals_with_space_separator: [' ', '.', 0],
      amount_with_period_and_space_separator: [' ', '.', 2],
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, token) {
      var rule = TOKENS[token];
      if (!rule) return m;
      var fixed = Math.abs(value).toFixed(rule[2]);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, rule[0]);
      var sign = value < 0 ? '-' : '';
      return rule[2] > 0 ? sign + whole + rule[1] + parts[1] : sign + whole;
    });
  }

  function initVolumeTiers() {
    var widgets = document.querySelectorAll('[data-kn-tiers]');
    if (!widgets.length) return;
    widgets.forEach(setupTierWidget);
  }

  function setupTierWidget(widget) {
    if (widget.dataset.knVtInit === '1') return;
    widget.dataset.knVtInit = '1';

    var formId = widget.getAttribute('data-form-id');
    var moneyFormat = widget.getAttribute('data-money-format');
    var unitCents = parseInt(widget.getAttribute('data-unit-cents'), 10) || 0;
    var removeMode = false;
    var addLabel = null;
    var REMOVE_LABEL = 'إزالة من السلة';

    /* الثيم يستبدل حقل الكمية ومحتوى الزر بعد الإضافة وعند تغيّر
       الفاريانت، لذلك لا نحتفظ بأي مرجع — نلتقط العناصر طازجة
       عند كل استخدام. الإمساك بمرجع واحد هو ما جعل الكمية
       المختارة تضيع وتصل السلة بقيمة 1. */
    function form() { return formId ? document.getElementById(formId) : null; }
    function button() {
      var f = form();
      return f ? f.querySelector('.product-form__submit') : null;
    }
    function qtyInput() {
      return (formId && document.querySelector('input[name="quantity"][form="' + formId + '"]')) ||
             document.querySelector('.product-form__quantity input[name="quantity"]');
    }
    function variantId() {
      var f = form();
      var el = f && f.querySelector('input[name="id"]');
      return el ? parseInt(el.value, 10) : NaN;
    }
    function checkedRadio() { return widget.querySelector('.kn-vt__radio:checked'); }
    /* سياسة المتجر: لا كسور في الأسعار — القيم كلها دراهم صحيحة،
       فنحذف الجزء العشري الصفري الذي يلصقه قالب العملة. */
    function fmt(cents) { return knpFormatMoney(cents, moneyFormat).replace(/([.,])00(?!\d)/, ''); }

    /* الثيم قد يستبدل قسم المنتج كاملاً (تبديل فاريانت مثلاً) فيموت
       عنصر الويدجت هذا وتولد نسخة ليكويد جديدة بلا مستمعين.
       نكتشف ذلك عند أول حدث ونعيد التهيئة على النسخة الجديدة. */
    function reinitIfReplaced() {
      if (document.contains(widget)) return true;
      var fresh = document.querySelector('[data-kn-tiers][data-form-id="' + formId + '"]');
      if (fresh && fresh.dataset.knVtInit !== '1') setupTierWidget(fresh);
      return false;
    }

    /* النسبة الفعلية لأي كمية = أعلى شريحة حدُّها الأدنى ≤ الكمية،
       وهي نفسها التي سيطبّقها "الخصم التلقائي" (بشرط حد أدنى
       للكمية) عند الدفع — فلا يعِد العرضُ بغير ما يحسم. */
    function selection() {
      var r = checkedRadio();
      var qty = r ? parseInt(r.getAttribute('data-qty'), 10) || 1
                  : parseInt((qtyInput() || {}).value, 10) || 1;
      var pct = 0;
      widget.querySelectorAll('.kn-vt__radio').forEach(function (t) {
        var tq = parseInt(t.getAttribute('data-qty'), 10) || 1;
        var tp = parseInt(t.getAttribute('data-pct'), 10) || 0;
        if (qty >= tq && tp > pct) pct = tp;
      });
      return { qty: qty, pct: pct };
    }
    /* سعر القطعة بعد الخصم مُقرَّباً دائماً للأعلى إلى درهم صحيح —
       نفس معادلة الفنكشن عند الدفع، فلا كسور ولا فروقات. */
    function unitPriced(pct) { return Math.ceil(unitCents * (100 - pct) / 10000) * 100; }

    function setActiveClasses() {
      var r = checkedRadio();
      widget.querySelectorAll('.kn-vt__item').forEach(function (item) {
        item.classList.toggle('is-active', !!r && item.contains(r));
      });
    }

    function syncQty() {
      var input = qtyInput();
      if (!input) return;
      var qty = selection().qty;
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && qty > max) qty = max;
      if (parseInt(input.value, 10) !== qty) {
        input.value = qty;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /* أسعار الصفوف: سعر القطعة الواحدة بعد الخصم، لا المجموع. */
    function paintRows() {
      widget.querySelectorAll('[data-kn-price]').forEach(function (el) {
        var pct = parseInt(el.getAttribute('data-pct'), 10) || 0;
        el.innerHTML = pct > 0
          ? fmt(unitPriced(pct)) + ' <small class="kn-vt__per">للقطعة</small>' +
            ' <s class="kn-vt__was">' + fmt(unitCents) + '</s>'
          : fmt(unitCents);
      });
    }

    /* الزر الذهبي: في وضع الإضافة يعرض إجمالي الشريحة المختارة،
       وبعد نجاح الإضافة يتحول إلى "إزالة من السلة". */
    function paintButton() {
      var btn = button();
      if (!btn || btn.disabled) return;
      var span = btn.querySelector('span');
      if (!span) return;
      if (addLabel === null) {
        var clone = span.cloneNode(true);
        var priced = clone.querySelector('.kn-atc__price');
        if (priced) priced.remove();
        var text = clone.textContent.trim();
        if (text && text !== REMOVE_LABEL) addLabel = text;
      }
      if (removeMode) {
        btn.classList.add('kn-atc--remove');
        span.textContent = REMOVE_LABEL;
        return;
      }
      btn.classList.remove('kn-atc--remove');
      if (addLabel === null) return;
      var sel = selection();
      span.textContent = addLabel + ' ';
      var priceEl = document.createElement('span');
      priceEl.className = 'kn-atc__price';
      /* الإجمالي كما يحسبه الدفع تماماً: سعر القطعة المقرَّب للأعلى
         (درهم صحيح) مضروباً بالكمية — الفنكشن يخصم بنفس المعادلة
         مبلغاً ثابتاً، فالزر والفاتورة رقم واحد دائماً. */
      priceEl.textContent = '— ' + fmt(unitPriced(sel.pct) * sel.qty);
      span.appendChild(priceEl);
    }

    function setRemove(on) {
      removeMode = !!on;
      paintButton();
    }

    /* هل الفاريانت الحالي داخل السلة فعلاً؟ السلة هي مصدر الحقيقة. */
    function refreshMode() {
      var vid = variantId();
      if (isNaN(vid)) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = (cart.items || []).some(function (i) {
            return i.variant_id === vid && i.quantity > 0;
          });
          setRemove(inCart);
        })
        .catch(function () {});
    }

    /* عدّاد السلة في الهيدر مكرّر بعدة نسخ (ديسكتوب/موبايل/ثابت)
       فنحدّثها كلها، لا أول نسخة فقط كما يفعل الثيم. */
    function updateCartIcon() {
      fetch(window.location.pathname + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections && sections['cart-icon-bubble'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var wrap = doc.querySelector('.shopify-section') || doc.body;
          document.querySelectorAll('[id="cart-icon-bubble"]').forEach(function (el) {
            el.innerHTML = wrap.innerHTML;
          });
        })
        .catch(function () {});
    }

    function removeFromCart() {
      var vid = variantId();
      if (isNaN(vid)) return;
      var btn = button();
      if (btn) btn.classList.add('loading');
      var updates = {};
      updates[vid] = 0;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartIcon();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          /* نبلّغ قناة الثيم أيضاً كي تحدِّث تبعياتها هي — شارة
             "(N في السلة)" وحدود الكمية في product-info مثلاً. */
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kn-volume-tiers', cartData: cart });
          }
          setRemove(false);
        })
        .catch(function () {})
        .finally(function () {
          var b = button();
          if (b) b.classList.remove('loading');
        });
    }

    /* اختيار شريحة: يضبط الكمية، ويُخرج الزر من وضع الإزالة إن كان فيه. */
    widget.addEventListener('change', function (e) {
      if (!e.target.classList || !e.target.classList.contains('kn-vt__radio')) return;
      setActiveClasses();
      if (removeMode) removeMode = false;
      syncQty();
      paintButton();
    });

    /* كتابة كمية يدوياً في الحقل (أي نسخة حالية منه): نعكسها على الشرائح. */
    document.addEventListener('change', function (e) {
      if (!document.contains(widget)) return;
      var input = e.target;
      if (!input || !input.matches || !input.matches('input[name="quantity"]')) return;
      if (input !== qtyInput()) return;
      var q = parseInt(input.value, 10) || 1;
      var match = widget.querySelector('.kn-vt__radio[data-qty="' + q + '"]');
      if (match) { match.checked = true; }
      else { var r = checkedRadio(); if (r) r.checked = false; }
      setActiveClasses();
      if (removeMode) removeMode = false;
      paintButton();
    });

    /* ضمانة لحظة الإرسال: قبل أن يبني الثيم FormData نزامن الكمية
       من الشريحة المختارة — مستمع capture على المستند يسبق مستمع
       النموذج دائماً، فلا يمكن أن تُرسل كمية غير المختارة. */
    document.addEventListener('submit', function (e) {
      if (!document.contains(widget)) return;
      if (e.target !== form()) return;
      if (removeMode) {
        e.preventDefault();
        e.stopPropagation();
        removeFromCart();
        return;
      }
      syncQty();
    }, true);

    /* نقرة "إزالة من السلة" تُلتقط قبل أن تُطلق إرسال النموذج.
       شريط الشراء الثابت يمرّر نقرته للزر الأصلي فيغطيه هذا أيضاً. */
    document.addEventListener('click', function (e) {
      if (!document.contains(widget)) return;
      if (!removeMode || !e.target.closest) return;
      var btn = e.target.closest('.product-form__submit');
      if (!btn || btn !== button()) return;
      e.preventDefault();
      e.stopPropagation();
      removeFromCart();
    }, true);

    /* زر الشراء السريع يقرأ النموذج بنفسه — نزامن الكمية قبله. */
    document.addEventListener('click', function (e) {
      if (!document.contains(widget)) return;
      if (e.target.closest && e.target.closest('.shopify-payment-button')) syncQty();
    }, true);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      if (PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
          if (!reinitIfReplaced()) return;
          var data = payload && payload.data ? payload.data : (payload || {});
          /* حدث قسمٍ آخر في الصفحة (منتج مميز مثلاً) ليس شأننا —
             وإلا التقطنا سعر فاريانت منتجٍ غريب. */
          if (data.sectionId && formId.indexOf(data.sectionId) === -1) return;
          var v = data.variant || null;
          if (v && typeof v.price === 'number') {
            unitCents = v.price;
            widget.setAttribute('data-unit-cents', String(v.price));
          }
          /* إعادة رسم الثيم للزر والحقل حول لحظة النشر — نتأخر خطوة عنه. */
          setTimeout(function () { paintRows(); refreshMode(); }, 30);
        });
      }
      if (PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          if (!reinitIfReplaced()) return;
          /* بعد نجاح الإضافة يصبح الفاريانت في السلة فيتحول الزر
             لوضع الإزالة — يظهر ذلك عند إغلاق رسالة البوب أب.
             ونحدّث كل نسخ عدّاد الهيدر — الثيم يحدّث أولاها فقط. */
          updateCartIcon();
          setTimeout(refreshMode, 30);
        });
      }
    }

    /* قد ينقر الزائر شريحةً قبل اكتمال تحميل هذا الملف —
       نبدأ من حالة الراديو الفعلية لا من افتراض. */
    setActiveClasses();
    syncQty();
    paintRows();
    paintButton();
    refreshMode();
  }

  function init() {
    initGallery();
    initStickyBar();
    initBandScroll();
    initVolumeTiers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* build: 1786467673 */
